<template>
  <div
    class="slider-container"
    ref="container"
    @touchstart="handleTouchStart"
    @touchmove="handleTouchMove"
    @touchend="handleTouchEnd"
  >
    <div
      class="slider"
      ref="slider"
      :style="{
        transform: `translateX(${
          -containerWidth * currentIndex + touchDeltaX
        }px)`,
      }"
    >
      <div
        v-for="(item, index) in sliders"
        :key="index"
        class="slide"
        :ref="'slide' + index"
      >
        <!-- <img
			:src="
			  screenWidth > 460
				? replaceCoverImage(slide.coverFeatured)
				: replaceCoverImage(slide.cover)
			"
			alt="slide"
		  /> -->
        <picture>
          <img
            :class="{ fullscreenIng: containerWidth < 460 }"
            :src="getCoverImage(screenWidth, item.coverFeatured, item.cover)"
            alt=""
          />
        </picture>
        <span class="genre"></span>
        <span class="title">
          <strong>{{ item.title }}</strong>
          •{{ item.genres }} • {{ item.countries }} • {{ item.year }}
        </span>
        <div class="buttons" style="z-index: 10">
          <router-link
            class="btn filled"
            :to="{ path: generateRouteUrl(item) }"
            >{{
              isBox ? $t("first-page.look") : $t("first-page.link")
            }}</router-link
          >
          <!-- <a href="" class="btn filled">Смотреть</a> -->
          <router-link class="btn" to="/main">
            {{ $t("first-page.entertainment-link") }}
          </router-link>
        </div>
      </div>
    </div>

    <div class="movie-slider-nav pagination">
      <span
        v-for="(slide, index) in sliders"
        :key="index"
        :class="{ active: index === currentIndex }"
        @click="goToSlide(index)"
      ></span>
    </div>

    <div class="controls">
      <span class="prev-button" @click.prevent="prevSlide">
        <svg
          width="55"
          height="55"
          viewBox="0 0 55 55"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="27.5"
            cy="27.5"
            r="27.5"
            fill="black"
            fill-opacity="0.4"
          />
          <path
            d="M17.9375 26.9375L29.9375 15C30.5 14.375 31.4375 14.375 32.0625 15C32.625 15.5625 32.625 16.5 32.0625 17.0625L21.0625 28L32 39C32.625 39.5625 32.625 40.5 32 41.0625C31.4375 41.6875 30.5 41.6875 29.9375 41.0625L17.9375 29.0625C17.3125 28.5 17.3125 27.5625 17.9375 26.9375Z"
            fill="white"
          />
        </svg>
      </span>
      <span class="next-button" @click.prevent="nextSlide">
        <svg
          width="55"
          height="55"
          viewBox="0 0 55 55"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="27.5"
            cy="27.5"
            r="27.5"
            fill="black"
            fill-opacity="0.4"
          />
          <path
            d="M36.0625 26.9375C36.625 27.5625 36.625 28.5 36.0625 29.0625L24.0625 41.0625C23.4375 41.6875 22.5 41.6875 21.9375 41.0625C21.3125 40.5 21.3125 39.5625 21.9375 39L32.875 28.0625L21.9375 17.0625C21.3125 16.5 21.3125 15.5625 21.9375 15C22.5 14.375 23.4375 14.375 24 15L36.0625 26.9375Z"
            fill="white"
          />
        </svg>
      </span>
    </div>
    <!-- <div class="pagination">
		<span
		  v-for="(slide, index) in sliders"
		  :key="index"
		  :class="{ active: index === currentIndex }"
		  @click="goToSlide(index)"
		></span>
	  </div> -->
  </div>
</template>

<script>
import cover from "@/mixins/cover";

export default {
  props: {
    sliders: {
      type: Array,
      required: true,
    },
    isBox: {
      type: Boolean,
    },
  },
  mixins: [cover],
  data() {
    return {
      containerWidth: 0,
      startX: 0,
      startY: 0,
      touchDeltaX: 0,
      currentIndex: 0,
      screenWidth: 0,
    };
  },
  mounted() {
    window.addEventListener("resize", this.getSliderWidth);
    window.addEventListener("resize", this.getScreenWidth);

    this.getSliderWidth();
    this.startAutoSlide(); // Запускаем автоперелистывание при монтировании компонента
    this.getScreenWidth();
  },
  beforeDestroy() {
    this.stopAutoSlide(); // Останавливаем автоперелистывание перед уничтожением компонента
    window.removeEventListener("resize", this.getScreenWidth);
  },
  destroyed() {
    window.removeEventListener("resize", this.getSliderWidth);
  },
  methods: {
    getSliderWidth() {
      this.containerWidth =
        this.$refs.slide0[0].offsetWidth +
        parseInt(getComputedStyle(this.$refs.slide0[0]).marginLeft) +
        parseInt(getComputedStyle(this.$refs.slide0[0]).marginRight);
    },
    getScreenWidth() {
      this.screenWidth = window.innerWidth;
    },
    // Добавляем метод для запуска автоперелистывания
    startAutoSlide() {
      this.autoSlideInterval = setInterval(() => {
        this.nextSlide(); // Вызываем метод для перехода к следующему слайду
      }, 5000); // Интервал автоперелистывания в миллисекундах (10 секунд)
    },
    // Добавляем метод для остановки автоперелистывания
    stopAutoSlide() {
      if (this.autoSlideInterval) {
        clearInterval(this.autoSlideInterval);
      }
    },
    handleTouchStart(event) {
      this.stopAutoSlide(); // Останавливаем автоперелистывание при начале взаимодействия с пользователем
      this.$refs.slider.style.transition = "none";
      this.startX = event.touches[0].clientX;
      this.startY = event.touches[0].clientY;
    },
    handleTouchMove(event) {
      const deltaX = event.touches[0].clientX - this.startX;
      const deltaY = event.touches[0].clientY - this.startY;

      if (Math.abs(deltaX) > Math.abs(deltaY)) {
        event.preventDefault(); // Предотвращаем прокрутку страницы при свайпе
        this.touchDeltaX = deltaX;
      }
    },
    handleTouchEnd(event) {
      const deltaX = event.changedTouches[0].clientX - this.startX;
      //   const deltaY = event.changedTouches[0].clientY - this.startY;

      //   if (Math.abs(deltaX) > Math.abs(deltaY)) {
      // Свайп горизонтальный
      if (Math.abs(deltaX) > this.containerWidth * 0.3) {
        // Прокрутили достаточно далеко, меняем слайд
        if (deltaX > 0) {
          this.switchSlideWithAnimation(
            (this.currentIndex - 1 + this.sliders.length) % this.sliders.length
          );
        } else {
          this.switchSlideWithAnimation(
            (this.currentIndex + 1) % this.sliders.length
          );
        }
      }
      //   }
      this.touchDeltaX = 0;
      this.startAutoSlide(); // Запускаем автоперелистывание после завершения взаимодействия с пользователем
    },
    // Метод для переключения слайдов с анимацией
    switchSlideWithAnimation(index) {
      this.currentIndex = index;
      this.$refs.slider.style.transition = "transform 1s ease";
      this.$refs.slider.style.transform = `translateX(-${
        this.containerWidth * this.currentIndex
      }px)`;
    },
    // Метод для переключения слайдов без анимации
    switchSlideChangeTimeAnimation(index, transitionTime) {
      this.currentIndex = index;
      this.$refs.slider.style.transition = transitionTime;
      this.$refs.slider.style.transform = `translateX(-${
        this.containerWidth * this.currentIndex
      }px)`;
    },
    nextSlide() {
      this.stopAutoSlide(); // Останавливаем автоперелистывание при начале взаимодействия с пользователем

      if (this.currentIndex + 2 > this.sliders.length) {
        this.switchSlideChangeTimeAnimation(
          (this.currentIndex + 1) % this.sliders.length,
          "transform 1s ease"
        );
      } else {
        this.switchSlideWithAnimation(
          (this.currentIndex + 1) % this.sliders.length
        );
      }

      this.startAutoSlide(); // Запускаем автоперелистывание после завершения взаимодействия с пользователем
    },
    prevSlide() {
      this.stopAutoSlide(); // Останавливаем автоперелистывание при начале взаимодействия с пользователем
      if (this.currentIndex - 1 < 0) {
        this.switchSlideChangeTimeAnimation(
          (this.currentIndex - 1 + this.sliders.length) % this.sliders.length,
          "transform 1s ease"
        );
      } else {
        this.switchSlideWithAnimation(
          (this.currentIndex - 1 + this.sliders.length) % this.sliders.length
        );
      }
      this.startAutoSlide(); // Запускаем автоперелистывание после завершения взаимодействия с пользователем
    },
    goToSlide(index) {
      this.stopAutoSlide(); // Останавливаем автоперелистывание при начале взаимодействия с пользователем
      this.switchSlideWithAnimation(index);
      this.startAutoSlide(); // Запускаем автоперелистывание после завершения взаимодействия с пользователем
    },
  },
};
</script>

<style scoped>
.slider-container {
  position: relative;
  min-height: 446px;
  overflow: hidden;
  -o-object-fit: cover;
  object-fit: cover;
  border-radius: 16px;
}

.slider {
  display: flex;
  /* transition: transform 0.3s ease; */
}

.slide {
  flex: 0 0 100%;
  width: 100%;
  position: relative;
  /* transition: transform 0.3s ease; */
}

.controls {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.pagination {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
}

/* .pagination span {
display: inline-block;
width: 10px;
height: 10px;
background-color: gray;
border-radius: 50%;
margin: 0 5px;
cursor: pointer;
} */

/* .pagination span.active {
background-color: black;
} */

.movie-slider-nav {
  position: absolute;
  bottom: 32px;
  text-align: center;
  height: 10px;
  padding: 4px 8px;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 8px;
  overflow: hidden;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-column-gap: 4px;
  -moz-column-gap: 4px;
  column-gap: 4px;
  left: 95px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.movie-slider-nav span {
  width: 16px;
  height: 2px;
  border-radius: 2px;
  background: #777777;
}

.pagination span.active {
  background-color: #f37920;
}

.title {
  font-size: 16px;
  font-family: "Circe", "PT Sans", sans-serif;
  color: white;
  position: absolute;
  bottom: 54px;
  left: 40px;
  width: 300px;
}

.movie-slider-item {
  scroll-snap-align: start;
  scroll-behavior: smooth;
  position: relative;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  -webkit-box-flex: 0;
  -ms-flex-positive: 0;
  flex-grow: 0;
  -ms-flex-preferred-size: 100%;
  flex-basis: 100%;
}

.slide img {
  min-height: 446px;
  max-width: 100%;
  -o-object-fit: cover;
  object-fit: cover;
}

picture:after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(rgba(0, 0, 0, 0)),
    to(rgb(0, 0, 0))
  );
  background: linear-gradient(rgba(0, 0, 0, 0), rgb(0, 0, 0));
  height: 285px;
}

.buttons {
  position: absolute;
  right: 40px;
  bottom: 54px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-column-gap: 10px;
  -moz-column-gap: 10px;
  column-gap: 10px;
}

.btn.filled {
  background: #f37920;
  color: white;
}

.btn {
  font-size: 16px;
  font-family: "Circe", "PT Sans", sans-serif;
  font-weight: 700;
  padding: 6px 20px 4px;
  border: 1px solid #f37920;
  color: white;
  border-radius: 16px;
}

.prev-button svg {
  margin-left: 28px;
}

.next-button svg {
  margin-right: 28px;
}

/* media */

@media screen and (max-width: 1023px) {
  .buttons {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    row-gap: 12px;
    width: 170px;
    bottom: 32px;
  }

  .btn {
    text-align: center;
  }
}

@media screen and (max-width: 767px) {
  .slide img {
    -o-object-position: 60% 40%;
    object-position: 60% 40%;
  }

  .title {
    left: 14px;
    bottom: 100px;
    width: calc(100% - 40px);
    max-width: 400px;
  }

  .buttons {
    bottom: 50px;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    right: auto;
    left: 14px;
    width: auto;
  }

  .movie-slider-nav {
    left: 71px;
    bottom: 20px;
  }
}

@media screen and (max-width: 538px) {
  .slide img {
    width: 100%;
    max-width: 455px;
    height: auto;
  }
}
</style>
